import * as React from 'react'
import {Box} from "@mui/material";
import { ArrowPercentage } from '@components';

export default function scoreColumn() {
	return {
		name: 'score', label: 'Score',
		options: {
			customBodyRowRender: (value, { scorePrev }) => {
				return <Box sx={{ textAlign: 'center' }}>
					<ArrowPercentage value={value} prev={scorePrev} />
				</Box>
			}
		}
	}
}